import { render, staticRenderFns } from "./pattern-suggestion-tab.vue?vue&type=template&id=170368ac&"
import script from "./pattern-suggestion-tab.vue?vue&type=script&lang=js&"
export * from "./pattern-suggestion-tab.vue?vue&type=script&lang=js&"
import style0 from "./pattern-suggestion-tab.vue?vue&type=style&index=0&id=170368ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports